export const getOperationUrl = (
    operationSoftwareId: string,
    expenseOrIncome: string,
) =>
    `/budget_operation_view/${operationSoftwareId}/${expenseOrIncome.toLowerCase()}`;
